import { render, staticRenderFns } from "./showImage.vue?vue&type=template&id=79b83724"
import script from "./showImage.vue?vue&type=script&lang=js"
export * from "./showImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports